jQuery(document).ready(function($){

  const modal = $('.pro_modal');
  const box = modal.find('.modelBox');

  // Target only the Color label's info icon
  const colorInfoIcon = $('.oz__option-label:contains("Color")')
    .closest('.oz__option-label-container')
    .find('.oz__option-info-icon');

  // Add click event only to that icon
  colorInfoIcon.on('click', function() {
    openPopup();
  });

  // --- Open popup function ---
  function openPopup(){
    modal.removeAttr('style');
    $('body').addClass('popup-open');
    modal.fadeIn(200, function(){
      box.css({top: '-100px', opacity: 0})
         .animate({top: '0px', opacity: 1}, 300);
    });
  }

  // --- Close popup function ---
  function closePopup(){
    box.animate({top: '-100px', opacity: 0}, 300, function(){
      modal.fadeOut(200, function(){
        $('body').removeClass('popup-open');
      });
    });
  }

  // --- Close triggers ---
  $(document).on('click', '.modelClose', closePopup);
  $(document).on('click', '.pro_modal', function(e){
    if ($(e.target).is('.pro_modal')) closePopup();
  });
  $(document).on('keyup', function(e){
    if (e.key === "Escape") closePopup();
  });

});
